import React from "react";

function ArcadeGames() {
  return (
    <>
      <div className="team-style-one-area default-padding">
        <div className="container">
          <div className="row">
            <div className="col-lg-8 offset-lg-2">
              <div className="site-heading text-center">
                <h4 className="sub-title">AI Developer</h4>
                <h2 className="title split-text-right split-text-in-right">
                  Meet our talent for <br /> intelligent solutions
                </h2>
              </div>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="team-style-one-items">
                <div className="team-style-one-item wow fadeInUp">
                  <div className="thumb">
                    <img
                      src="https://validthemes.net/site-template/robok/assets/img/team/13.jpg"
                      alt="Image Not Found"
                    />
                  </div>
                  <div className="info">
                    <h4>
                      <a href="#">Arcade Games</a>
                    </h4>
                  </div>
                </div>

                <div
                  className="team-style-one-item wow fadeInUp"
                  data-wow-delay="100ms"
                >
                  <div className="thumb">
                    <img
                      src="https://validthemes.net/site-template/robok/assets/img/team/12.jpg"
                      alt="Image Not Found"
                    />
                  </div>
                  <div className="info">
                    <h4>
                      <a href="#">Action & Adventure</a>
                    </h4>
                  </div>
                </div>

                <div
                  className="team-style-one-item wow fadeInUp"
                  data-wow-delay="200ms"
                >
                  <div className="thumb">
                    <img
                      src="https://validthemes.net/site-template/robok/assets/img/team/11.jpg"
                      alt="Image Not Found"
                    />
                  </div>
                  <div className="info">
                    <h4>
                      <a href="#">Casino & Cards</a>
                    </h4>
                  </div>
                </div>

                <div
                  className="team-style-one-item wow fadeInUp"
                  data-wow-delay="300ms"
                >
                  <div className="thumb">
                    <img
                      src="https://validthemes.net/site-template/robok/assets/img/team/14.jpg"
                      alt="Image Not Found"
                    />
                  </div>
                  <div className="info">
                    <h4>
                      <a href="#">Board Games</a>
                    </h4>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12">
              <div className="team-style-one-items">
                <div className="team-style-one-item wow fadeInUp">
                  <div className="thumb">
                    <img
                      src="https://validthemes.net/site-template/robok/assets/img/team/13.jpg"
                      alt="Image Not Found"
                    />
                  </div>
                  <div className="info">
                    <h4>
                      <a href="#">PvP Battle</a>
                    </h4>
                  </div>
                </div>

                <div
                  className="team-style-one-item wow fadeInUp"
                  data-wow-delay="100ms"
                >
                  <div className="thumb">
                    <img
                      src="https://validthemes.net/site-template/robok/assets/img/team/12.jpg"
                      alt="Image Not Found"
                    />
                  </div>
                  <div className="info">
                    <h4>
                      <a href="#">Sports and Fantasy Leagues</a>
                    </h4>
                  </div>
                </div>

                <div
                  className="team-style-one-item wow fadeInUp"
                  data-wow-delay="200ms"
                >
                  <div className="thumb">
                    <img
                      src="https://validthemes.net/site-template/robok/assets/img/team/11.jpg"
                      alt="Image Not Found"
                    />
                  </div>
                  <div className="info">
                    <h4>
                      <a href="#">Battle Games</a>
                    </h4>
                  </div>
                </div>

                <div
                  className="team-style-one-item wow fadeInUp"
                  data-wow-delay="300ms"
                >
                  <div className="thumb">
                    <img
                      src="https://validthemes.net/site-template/robok/assets/img/team/14.jpg"
                      alt="Image Not Found"
                    />
                  </div>
                  <div className="info">
                    <h4>
                      <a href="#">Play to Earn</a>
                    </h4>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12">
              <div className="team-style-one-items">
                <div className="team-style-one-item wow fadeInUp">
                  <div className="thumb">
                    <img
                      src="https://validthemes.net/site-template/robok/assets/img/team/13.jpg"
                      alt="Image Not Found"
                    />
                  </div>
                  <div className="info">
                    <h4>
                      <a href="#">NFT RPG Games</a>
                    </h4>
                  </div>
                </div>

                <div
                  className="team-style-one-item wow fadeInUp"
                  data-wow-delay="100ms"
                >
                  <div className="thumb">
                    <img
                      src="https://validthemes.net/site-template/robok/assets/img/team/12.jpg"
                      alt="Image Not Found"
                    />
                  </div>
                  <div className="info">
                    <h4>
                      <a href="#">Simulation Games</a>
                    </h4>
                  </div>
                </div>

                <div
                  className="team-style-one-item wow fadeInUp"
                  data-wow-delay="200ms"
                >
                  <div className="thumb">
                    <img
                      src="https://validthemes.net/site-template/robok/assets/img/team/11.jpg"
                      alt="Image Not Found"
                    />
                  </div>
                  <div className="info">
                    <h4>
                      <a href="#">Adventure Games</a>
                    </h4>
                  </div>
                </div>

                <div
                  className="team-style-one-item wow fadeInUp"
                  data-wow-delay="300ms"
                >
                  <div className="thumb">
                    <img
                      src="https://validthemes.net/site-template/robok/assets/img/team/14.jpg"
                      alt="Image Not Found"
                    />
                  </div>
                  <div className="info">
                    <h4>
                      <a href="#">Move to Earn Games</a>
                    </h4>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ArcadeGames;
